
<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">品種詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_PRODUCT_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout :key="index" row v-for="(item, index) in form" wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="item.label"
                :readonly="item.isId && id != null"
                :rules="
                  item.required
                    ? [(v) => !!v || `${item.label} is required`]
                    : []
                "
                v-model.trim="root[item.name]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                url="/product-groups/all-kv"
                label="品種グループ"
                v-model="root.productGroupName"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs12>
              <v-checkbox
                label="物流社内品番ありEIAJに表示。"
                v-model="root.showLogisticsSku"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import RemoteAutocomplete from "../../components/RemoteAutocomplete.vue";
/* eslint-disable no-console */
export default {
  components: { RemoteAutocomplete },
  data() {
    return {
      valid: null,
      id: null,
      root: {},
      form: [
        { label: "品種CD", name: "code", required: true, isId: true },
        { label: "品種名", name: "name", required: true },
        { label: "品種名英文", name: "englishName" },
        { label: "機種名称", name: "model" },
      ],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  methods: {
    returnToList() {
      this.$router.push({
        name: "M0230",
      });
    },
    remove() {
      this.$http
        .delete(`/products/${this.id}`)
        .then((res) => {
          return res.data;
        })
        .then(() => {
          this.returnToList();
        })
        .catch();
    },
    save() {
      this.$http
        .post("/products", { ...this.root })
        .then(() => {
          return this.$http
            .post("/purchase-orders/po-product", this.root)
            .then(() => {
              return this.returnToList();
            });
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    initData() {
      this.root.code = this.$route.query.code;
      this.root.name = this.$route.query.name;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
